import { render, staticRenderFns } from "./rockyId.vue?vue&type=template&id=d9fb6aa0&scoped=true&lang=pug&"
import script from "./rockyId.vue?vue&type=script&lang=js&"
export * from "./rockyId.vue?vue&type=script&lang=js&"
import style0 from "./rockyId.vue?vue&type=style&index=0&id=d9fb6aa0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fb6aa0",
  null
  
)

export default component.exports